var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",attrs:{"id":"sidebar"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"tab-content"},[_c('router-view')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }